import React from "react"
import _ICON_ALLERGY_GRAY from "../../../../resources/images/icon/icon_user_circleinfo06dis.png"
export default (props) => {

    return(
        <div className="nothing-box">
            <div>
                <img src={ _ICON_ALLERGY_GRAY} alt="" />
                <p>
                    등록된 알레르기가 없습니다.
                </p>
            </div>
        </div>
    )
}